function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35 17c0 9.4-7.7 17-17.2 17-3 0-5.8-.8-8.3-2.1l-9.5 3 3.1-9.1C1.5 23.2.6 20.2.6 17 .6 7.6 8.3 0 17.8 0S35 7.6 35 17zM17.8 2.7C9.8 2.7 3.4 9.1 3.4 17c0 3.1 1 6 2.8 8.4l-1.8 5.3 5.6-1.8c2.3 1.5 5 2.4 7.9 2.4 8 0 14.4-6.4 14.4-14.3S25.8 2.7 17.8 2.7zM26.5 21c-.1-.2-.4-.3-.8-.5s-2.5-1.2-2.9-1.4c-.4-.1-.7-.2-.9.2-.3.4-1.1 1.4-1.3 1.6-.2.3-.5.3-.9.1-.4-.2-1.8-.7-3.4-2.1-1.3-1.1-2.1-2.5-2.3-2.9-.2-.4 0-.6.2-.9.2-.2.4-.5.6-.7.2-.2.3-.4.4-.7.1-.3.1-.5 0-.7-.1-.2-.9-2.3-1.3-3.1-.3-.8-.7-.7-.9-.7h-.8c-.3 0-.7.1-1.1.5-.4.4-1.5 1.4-1.5 3.5s1.5 4 1.7 4.3c.2.3 2.9 4.6 7.2 6.3 4.3 1.7 4.3 1.1 5.1 1 .8-.1 2.5-1 2.8-2 .2-.8.2-1.7.1-1.8z"
});

function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "ab575ed119a56b2525ff5c79d4546078.svg";
export { SvgWhatsapp as ReactComponent };